import React, { useRef } from "react";
import Cards from "../components/Cards";
import Footer from "../components/Footer";
import OurStory from "../components/OurStory";
import Navbar from "../components/navbar/GuideNavbar";
import { useState } from "react";
import SubNew from "../components/SubNew";
import Access from "../components/Access";
import GuideInfo from "../components/form/ToolGuideInfo";
import ChatInfo from "../components/form/ToolChatInfo";
import WhyUsPage from "../components/WhyUsPage";
// import Deliverables from '../components/Deliverables';
import ProfesionalValue from "../components/ProfesionalValue";
import GuideModal from "../components/modal/guideModal/guideModal";
// import Whyusd from '../components/Whyusd';

import EventInfo from "../components/form/EventInfo";
import EventDetails from "../components/event/EventHeader";

const Guide = () => {
  const [clicked, isClicked] = useState(false);

  return (
    <div className="overflow-hidden">
      <Navbar />
      <EventDetails />
      <EventInfo />
      {/* {clicked && <ChatInfo />} */}

      <SubNew />
      <Footer />
      {<GuideModal />}
    </div>
  );
};

export default Guide;
